module.exports = __webpack_public_path__ + "static/img/risk_banner_h5.b3f99f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/productPartner/risk_banner_h5.png
// module id = 3Ezt
// module chunks = 34